export default {
  message: {
    Tour: {
      continue: "继续",
      back: "返回",
      finish: "完成"
    },
    Login: {
      title: "家长登录",
      sign_in: "登录",
      login_fail:
        "验证失败。请重试或联系学校寻求帮助。",
      forgot_password: "忘记密码",
      create_account: "创建账户",
      password: "密码",
      confirm_password: "确认密码",
      password_reminder: "密码提醒",
      enter_email: "请输入您的电子邮件地址",
      validation_error: "验证错误信息",
      password_reminder_error_no_user_register:
        "未找到您输入的用户名。请重试或创建新账户。",
      password_reminder_error_no_user: "未找到您输入的用户名。",
      password_reminder_sent: "已向 {email} 发送包含进一步说明的电子邮件。",
      password_reminder_sent_message:
        "电子邮件可能需要几分钟才能到达。如未在收件箱中看到，请检查垃圾邮件文件夹。",
      password_trouble_email: "如仍有问题，请联系 {email}。",
      password_trouble_school:
        "如仍有问题，请联系学校寻求帮助。",
      return_to_sign_in: "返回登录",
      create_my_account: "创建我的账户",
      or_sign_in_with: "或使用以下方式登录",
      password_reset: "请为您的账户选择新密码。",
      password_reset_warning:
        "如果您未请求更改密码，请立即联系学校管理员。",
      password_update: "选择新密码",
      password_update_confirm: "确认新密码",
      password_update_success: "您的新密码已保存。"
    },
    AccountSettings: {
      title: "账户设置",
      first_name: "名字",
      last_name: "姓氏",
      email: "电子邮件",
      username: "用户名",
      password: "密码",
      students: "学生",
      teachers: "教师",
      external_id: "外部ID",
      phone: "电话号码",
      phone_required: "电话号码为必填项",
      edit: "编辑",
      remove: "删除",
      add: "添加",
      remove_message: "确定要删除此学生姓名吗？",
      yes: "是",
      no: "否",
      add_student: "添加学生",
      close: "关闭",
      save: "保存更改",
      cancel: "取消",
      student_alert_message: "您必须至少输入一名学生。",
      logout: "退出"
    },
    Navbar: {
      my_meetings: "我的会议",
      language: "简体中文",
      help: "帮助",
      account_settings: "账户设置",
      logout: "退出"
    },
    SubNavbar: {
      meeting: "会议",
      event: "活动",
      print: "打印",
      email: "电子邮件",
      export: "导出"
    },
    ConferenceCard: {
      add_edit_meetings: "添加/编辑会议",
      opening: "开放",
      closed: "已关闭"
    },
    Agenda: {
      full_agenda: "完整议程",
      empty_state_title: "我们未找到您的任何会议。",
      empty_state_message: "如有疑问，请联系学校代表。",
      confirmation_modal_title: "议程已确认",
      confirmation_modal_message:
        "您的议程已成功确认，已向您发送电子邮件。",
      complete_button: "完成！"
    },
    AgendaCard: {
      room: "房间不可用",
      room_with_value: "房间：{room}",
      virtual_meeting: "虚拟会议",
      all_conferences: "所有会议",
      conference: "会议",
      student: "学生",
      meeting_with: "会议对象",
      date_time: "日期/时间",
      meeting_type: "会议类型",
      location: "地点",
      comment: "评论",
      action: "操作",
      delete: "删除",
      add_comment: "添加评论",
      join: "加入会议",
      choose_meeting_type: "选择会议类型",
      in_person: "面对面",
      phone: "电话",
      callback: "回电",
      virtual: "虚拟",
      unavailable: "不可用",
      tooltip_translator:
        "翻译服务不保证提供，但学校将尽力确保可用。",
      translator_requested: "已请求翻译",
      clear_translator: "清除翻译请求",
      need_translator: "需要翻译？",
      choose_language: "选择语言"
    },
    ScheduleMatrix: {
      no_teachers_title: "未选择教师或团队。",
      no_teachers_message: "请选择教师以查看其会议时间。",
      choose_teachers_button: "查看可用的教师或团队",
      choose_student: "为哪位学生？",
      cancel: "取消"
    },
    Matrix: {
      teachers: "教师",
      agenda: "审核并继续"
    },
    DrawerTeachers: {
      teachers: "教师",
      name: "姓名",
      description: "描述",
      student: "学生",
      teacher_team: "教师/团队",
      show_more: "显示更多教师",
      show_all: "显示学校所有教师",
      selected: "已选 ({count})",
      closeDrawer: "继续安排",
      search: "搜索教师或团队",
      not_available: "该教师在 {date} 没有可用会议时间。"
    },
    DrawerAgenda: {
      no_meetings_title: "您没有安排的会议。",
      no_meetings_message: "选择教师和时段后，会议将显示在此处。",
      new_meeting_label: "新建",
      cancel_button: "取消",
      student_label: "学生",
      meeting_type_location: "会议类型/地点",
      comment_label: "评论",
      save_comment_button: "保存评论",
      confirm_label: "请确认：",
      confirm_cancel_button: "是的，取消我与 ",
      do_not_cancel_button: "不取消",
      confirm_agenda_button: "确认此议程",
      confirm_agenda_message_line1: "您随时可以返回修改。",
      confirm_agenda_message_line2: "您当前的议程将通过电子邮件发送给您。"
    },
    EmailConsent: {
      message:
        "为保护您的隐私和安全，我们需要您同意接收系统发送到您电子邮件的通信。",
      consent: "同意"
    }
  }
};
